import { checkForOverride } from "../helpers/theme";

export default function Progress ({ cue, baseTheme, baseThemeId }) {
  return (
    <>
      <div
         className="relative rounded flex items-center h-[5vh] w-s9"
         style={{
          background: checkForOverride(baseTheme, cue.type, cue.theme, 'background', "colour2"),
        }}
        >
         <span
          style={{
           width: `${Math.min(parseInt(cue.percent), 100)}%`,
           background: checkForOverride(baseTheme, cue.type, cue.theme, 'background', "colour"),
          }}
          className="absolute rounded h-full w-100 opacity-100 z-0 transition-all duration-300"
         ></span>
         <div className="px-s2 z-10">
         </div>
         
         <div
          className="flex z-10 justify-between w-full"
         >
         </div>
        </div>
    </>
  )
}